/**
 * TB-App API – Generated by orval 🍺
 * Do not edit manually.
 */

export type TherapyComplianceDtoTherapyCompliance =
  (typeof TherapyComplianceDtoTherapyCompliance)[keyof typeof TherapyComplianceDtoTherapyCompliance];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TherapyComplianceDtoTherapyCompliance = {
  YES: 'YES',
  NO: 'NO',
} as const;
